import { render, staticRenderFns } from "./ReopenDialog.vue?vue&type=template&id=6399b4e4&scoped=true"
import script from "./ReopenDialog.vue?vue&type=script&lang=js"
export * from "./ReopenDialog.vue?vue&type=script&lang=js"
import style0 from "./ReopenDialog.vue?vue&type=style&index=0&id=6399b4e4&prod&lang=css"
import style1 from "./ReopenDialog.vue?vue&type=style&index=1&id=6399b4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6399b4e4",
  null
  
)

export default component.exports